import 'alpinejs';
import 'lazysizes';
import setVhSize from './lib/setVhSize';
import TeamMember from './modules/TeamMember';
import TeamOverlay from './modules/TeamOverlay';
import JobList from './modules/JobList';
import manifest from './manifest';
import Filter from './modules/Filter';
import TeamGrid from './modules/TeamGrid';
import Header from './modules/Header';
import VideoPlayer from './modules/VideoPlayer';
import AccordionAnimation from './modules/AccordionAnimation';
import EntryIndex from './modules/EntryIndex';
import Toggle from './modules/Toggle';
import TextChanger from './modules/TextChanger';
import Accordion from './modules/Accordion';

document.documentElement.classList.remove('no-js');
document.querySelectorAll('[data-module]').forEach(module => {
  const name = module.getAttribute('data-module');
  const Module = manifest[name];
  if (!Module) {
    // eslint-disable-next-line no-console
    console.error(
      `Module "${name}" does not exist in the manifest. Did you forget to add it?`
    );
    return;
  }

  Module(module);
});

// Alpine components
window.TeamMember = TeamMember;
window.TeamOverlay = TeamOverlay;
window.Filter = Filter;
window.TeamGrid = TeamGrid;
window.JobList = JobList;
window.Header = Header;
window.VideoPlayer = VideoPlayer;
window.EntryIndex = EntryIndex;
window.Toggle = Toggle;
window.AccordionAnimation = AccordionAnimation;
window.TextChanger = TextChanger;
window.Accordion = Accordion;

window.FormField = function FormField() {
  return {
    focus: false,
    hasValue: false,
    handleBlur() {
      this.focus = false;
      this.hasValue = this.$refs.input.value;
    },
    handleFocus() {
      this.focus = true;
    },
  };
};

setVhSize();

// Do any custom work that needs to wait until the background animation is ready
document.addEventListener('animationReady', () => {});
